<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.type" slot="prepend" placeholder="请选择">
                            <el-option label="词汇" :value="1"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button
                v-if="$utils.have('/letter/forbidden/save')"
                type="primary"
                icon="el-icon-add"
                @click="visible = true;"
                size="small"
                >添加词汇</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                v-loading="fetchLoading"
                size="small"
                stripe
            >
                <el-table-column prop="content" label="词汇"></el-table-column>
                <el-table-column width="150" prop="createTime" label="添加时间"></el-table-column>
                <el-table-column fixed="right" width="80" label="操作" >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-delete"
                            @click="del(scope.row.id)"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="tableData.length > 0" class="page-pagination-box">
            <el-pagination
                background
                @size-change="search"
                @current-change="fetch"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="totalCount || 0">
            </el-pagination>
        </div>
        <el-drawer
            title="添加词汇"
            :visible.sync="visible"
            class="form-drawer"
            :append-to-body="true"
            :wrapper-closable="false"
            direction="rtl"
            size="400px"
        >
            <div class="drawer-content">
                <el-form ref="formData" :model="formData" :rules="rules" label-position="top">
                    <el-form-item prop="words">
                        <template slot="label">词汇</template>
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 4, maxRows: 8}"
                            placeholder="请输入内容"
                            maxlength="500"
                            show-word-limit
                            v-model="formData.words">
                        </el-input>
                        <small class="MT10">
                            <span class="el-icon-warning"></span>  
                            多个词汇之间用逗号，每个词汇最长不允许超过10个字符
                        </small>
                    </el-form-item>
                </el-form>
            </div>
            <div class="drawer-footer">
                <el-button @click="visible = false">取消</el-button>
                <el-button :loading="saveLoading" type="primary" @click="save()">提交</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
const defaultQuery = {
    pageNo: 1,
    pageSize: 15,
    type: 1,
    value: ''
};
export default {
    data() {
        return {
            params: {...defaultQuery},
            fetchLoading: false,
            tableData: [],
            totalCount: 0,
            visible: false,
            formData: {
                words: ''
            },
            rules: {
                words: [{ required: true, message: "请添加词汇" }],
            },
            saveLoading: false
        };
    },
    mounted(){
        this.fetch();
    },
    methods: {
        async fetch() {
            this.fetchLoading = true;
            const response = await this.$request({
                url: "/letter/forbidden/list",
                method: "POST",
                data: this.params,
            })
            const {state, msg, result} = response.data;
            this.fetchLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.tableData = result.result;
            this.totalCount = result.totalCount;
        },
        save () {
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    const words = this.formData.words.split(/[\n\s+,，]/);
                    if(words.findIndex(item => item.length > 10) !== -1) return this.$message.error('单个词汇最多允许填写10个字符');
                    this.saveLoading = true;
                    const response = await this.$request({
                        url: "/letter/forbidden/save",
                        method: "POST",
                        params: this.formData,
                    });
                    const {msg, state} = response.data;
                    this.saveLoading = false;
                    if (state != 1) return this.$message.error(msg);
                    this.$message.success('添加词汇成功');
                    this.visible = false;
                    this.formData.words = '';
                    this.search();
                }
            });
        },
        del (id) {
            this.$confirm('确认删除该屏蔽词?', '删除屏蔽词', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(async () => {
                const response = await this.$request({
                    url: "/letter/forbidden/delete",
                    method: "POST",
                    params: {id},
                });
                const {msg, state} = response.data;
                if (state != 1) return this.$message.error(msg);
                this.$message.success('屏蔽词删除成功');
                this.fetch();
            })
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.fetch();
        },
        //重置搜索
        reset() {
            this.params = {...defaultQuery};
            this.search();
        }
    },
};
</script>
